import { X } from 'lucide-react';
import { useContext } from 'react';
import { CalendlyContext } from '@/App';

const CalendlyPopup = () => {
  const { isOpen, setIsOpen } = useContext(CalendlyContext);

  return (
    <>
      <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center" style={{ display: isOpen ? 'flex' : 'none' }}>
        <div className="bg-white rounded-lg p-4 w-full max-w-4xl h-[600px] relative overflow-hidden">
          <button
            onClick={() => setIsOpen(false)}
            className="absolute top-4 right-4 z-[60] bg-white/80 hover:bg-white rounded-full p-2 shadow-md hover:shadow-lg transition-all duration-300"
          >
            <X className="w-6 h-6 text-gray-700 hover:text-gray-900" />
          </button>
          <div className="w-full h-full">
            <iframe
              src="https://calendly.com/advensify/30min"
              width="100%"
              height="100%"
              frameBorder="0"
              title="Schedule a Consultation"
              className="relative z-10"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CalendlyPopup; 